var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-container"},[_c('overlay-loader',{attrs:{"loading":_vm.loading}}),_c('ProductForm',{attrs:{"idProduct":_vm.idProduct,"product":_vm.product}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }